import React from "react";
import { Breadcrumbs } from "../../../AbstractElements";
import { BootstrapBasicTable, BootstrapTable } from "../../../Constant";
import { Container, Row } from "reactstrap";
import BasicTableBorderBottomColor from "./BasicTableBorderBottomColor";
import InverseTable from "./InverseTable";
import { HoverableRows } from "./HoverableRows";
import InverseTablePrimary from "./InverseTablePrimary(";
import { CaptionTable } from "./CaptionTable";
import TableHeadOptions from "./TableHeadOptions";
import { StripedRowInverseTable } from "./StripedRowInverseTable";
import { BreckpointSpecific } from "./BreckpointSpecific";
import { ResponsiveLightBackground } from "./ResponsiveLightBackground";
import { SizingTables } from "./SizingTables";
import { CustomColorHoverStripped } from "./CustomColorHoverStripped";
import { DashedBorder } from "./DashedBorder";

const BasicTablesCntainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={BootstrapBasicTable} parent={BootstrapTable} title={BootstrapBasicTable} />
      <Container fluid>
        <Row>
          <BasicTableBorderBottomColor />
          <InverseTable />
          <HoverableRows />
          <InverseTablePrimary />
          <CaptionTable />
          <TableHeadOptions/>
          <StripedRowInverseTable/>
          <BreckpointSpecific/>
          <ResponsiveLightBackground/>
          <SizingTables/>
          <CustomColorHoverStripped/>
          <DashedBorder/>
        </Row>
      </Container>
    </>
  );
};

export default BasicTablesCntainer;
